import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AlarisAuthService } from '@campaign-portal/components-library';

@Injectable({
	providedIn: 'root',
})
class ActivateGuardService {
	constructor(
		private readonly authService: AlarisAuthService,
		private readonly router: Router
	) {}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		this.authService.resetAuth();

		if (route.queryParams.key) {
			return true;
		}

		this.router.navigate(['']).then();
		return false;
	}
}

export const ActivateGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean =>
	inject(ActivateGuardService).canActivate(route);
